module.exports = __webpack_public_path__ + "Assets/8b1cbfbd-4fa3-4330-8e32-552125871646.woff";